export default {
  dbi_genre_profile: 'Genre Profile',
  dbi_genre_performance: 'Genre Performance',
  dbi_genre_profile_stats_mscience_info:
    'Mscience daily metrics are available for the US only.',
  dbi_genre_profile_stats_mobile_info:
    'The Mobile Revenue and Downloads take the sum value of all available games within Databrain database.',
  dbi_genre_profile_search_games: 'Search any games in the table',
  dbi_genre_profile_search_countries: 'Search any coutries in the table',
  dbi_genre_profile_search_companies: 'Search any companies in the table',
  dbi_genre_profile_search_genre: 'Search any genre in the table',

  dbi_genre_profile_metric_mobile_downloads: 'Mobile Downloads',
  dbi_genre_profile_metric_percent_market: '% of Market',
  // 详情页
  dbi_genre_profile_strategy: 'Strategy',
  dbi_genre_profile_by_countries: 'By Countries',
  dbi_genre_profile_data_source_info_mobile:
    'Revenue and download metrics are sourced from Sensor Tower. Under Sensor Tower’s genre system, these figures reflect market-level totals from the Market Size module rather than an aggregate of all individual titles in the database.',
  dbi_genre_profile_data_source_info:
    'Both revenue and download data are based on an aggregation of all data available in the database.',
  dbi_genre_profile_data_source_info_pc_console:
    'Both online revenue and retail revenue are based on an aggregation of all data available in the database.',
  dbi_genre_profile_data_desc: 'Data Desription',
  dbi_genre_profile_steam_pcu: 'Steam PCU',
  dbi_genre_profile_steam_trending: 'Steam New&Trending',
  dbi_genre_profile_monthly_digital_revenue: 'Monthly Digital Revenue($)',
  dbi_genre_profile_monthly_physical_revenue: 'Monthly Physical Revenue($)',
  dbi_genre_profile_newzoo_mau: 'MAU',
  dbi_genre_profile_daily_steam_pcu: 'Daily Steam PCU',

  dbi_genre_profile_big_riser_bubble_dominate:
    'Remained on the Big Riser at least 7 Days.',
  dbi_genre_profile_big_riser_bubble_new: 'New game to the Big Riser.',
  dbi_genre_profile_big_riser_bubble_other:
    'Remained on the Big Riser at least 2 Days.',
  dbi_genre_profile_big_riser_bubble_keyword_dominate: '7 Days',
  dbi_genre_profile_big_riser_bubble_keyword_new: 'New',
  dbi_genre_profile_big_riser_bubble_keyword_other: 'Remained',
  dbi_genre_profile_new_blockbuster_games_tips:
    'The presented New Blockbuster Games are from the recently released Big Riser Games, which are games that have entered the top list by Revenue & Downloads provided by data.ai for the first time.',
  dbi_genre_profile_new_blockbuster_pc_tip:
    'The presented New Blockbuster Games are from the recently released Big Riser Games, which are games that entered the top list of Steam Top Seller,Mscience digital revenue, and MAU for the first time.',
  dbi_genre_profile_new_blockbuster_module_name: 'New Blockbuster Games',
  dbi_genre_profile_market_crten_module_name: 'Market CR10 By Revenue',
  dbi_genre_profile_big_riser_module_name: 'Big Riser',
  dbi_genre_profile_new_release_module_name: 'New Release',
  dbi_genre_profile_upcoming_module_name: 'Upcoming',

  dbi_genre_profile_trend: 'Trends',
  dbi_genre_profile_top_games: 'Top Games',
  dbi_genre_profile_top_countries: 'Top Countries',
  dbi_genre_profile_top_companies: 'Top Companies',
  dbi_genre_profile_data_category: 'Data Category',

  dbi_genre_profile_top_game_revenue: 'Top Games By Revenue',
  dbi_genre_profile_top_game_digital_revenue: 'Top Games By Digital Revenue',

  dbi_genre_profile_main_genre_tips:
    'The main genre is not equal to the sum of the sub genres because the IEGG genre of game has one main genre and two sub genres.',
};
